/**
 * 描述：策划中心
 * 日期：2017-11-9
 * 作者：Bai.Zhiming
 */
angular.module('planningCenterModule', [
    'planningCenterLeftModule', // 左侧导航模块
    'planningCenterRouterModule', // 策划中心主路由
    'planningCenterServiceModule', // 策划中心公用服务
    'planningCenterDirModule', // 策划中心公用指令
    'realTimeCluesModule', // 实时线索模块
    'commandMoudle', // 协同指挥
    'hotFocusModule', // 热点聚焦
    'rankingListModule', // 排行榜单
    'eventAnalysisModule', // 事件分析
    'mediaLaboratoryModule', // 媒体实验室
    'taskAssignmentModule', // 任务指派
]).controller('planningCenterCtrl', ['$scope', '$state',
    function($scope, $state) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                src: ''
            };
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            $scope.data.src = $state.params.url ? decodeURIComponent($state.params.url) : ''; // 判断是否是从im跳转过来，im跳转过来会把策划的目标地址带到后面
        }
    }
]);
